import React from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';

const MyProfile: React.FC = () => {
    return (
        <>
            {/* page title */}
            <div className="container py-3">
                <div className="row align-items-center page-title">
                    <div className="col col-sm mb-3 mb-sm-0">
                        <h6 className="mb-0">My Profile</h6>
                        <p className="text-secondary small">Checkout personal and plan details</p>
                    </div>

                    <div className="col-auto ps-0 position-relative mb-3 mb-sm-0">
                        <a href="adminuiux-account-setting.html" className="btn btn-theme ms-2"><i className="bi bi-gear"></i> Edit</a>
                    </div>
                </div>
                <nav aria-label="breadcrumb" className="breadcrumb-theme bg-theme-1-subtle px-2 py-1 mt-0 mt-sm-3 rounded">
                    <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item bi"><Link to="/app/dashboard"><i className="bi bi-house-door me-2"></i> DevUIUX</Link></li>
                        <li className="breadcrumb-item bi active" aria-current="page"> My Profile</li>
                    </ol>
                </nav>
            </div>

            {/* content */}
            <div className="container" id="main-content">

                <div className="row gx-3 gx-lg-4">
                    <div className="col-12 col-lg-5 col-xl-4">

                        {/* profile details */}
                        <div className="card mb-3 mb-lg-4 overflow-hidden">
                            <div className="card-body">
                                <figure className="height-250 w-100 coverimg z-index-0 mb-3 mb-lg-4 rounded">
                                    <img src={asset('assets/img/adminuiux/user-6.jpg')} alt="" />
                                </figure>

                                <h2 className="mb-1">DevUIUX</h2>
                                <p className="text-secondary mb-3">Creative UIUX Designer</p>

                                <p className="text-secondary mb-2"><i className="bi bi-people me-2 align-middle text-theme-1"></i> <span className="align-middle">Admin</span></p>
                                <p className="text-secondary mb-2"><i className="bi bi-question-circle me-2 align-middle text-theme-1"></i> <span className="align-middle">happy@adminuiuxi.com</span></p>
                                <p className="text-secondary mb-2"><i className="bi bi-telephone me-2 align-middle text-theme-1"></i> <span className="align-middle">+91 9856225A588</span></p>
                                <p className="text-secondary mb-2"><i className="bi bi-cake me-2 align-middle text-theme-1"></i> <span className="align-middle">15/09/2000</span></p>
                                <p className="text-secondary mb-2"><i className="bi bi-calendar-event me-2 align-middle text-theme-1"></i> <span className="align-middle">Member since 2023</span></p>
                                <p className="text-secondary d-flex"><i className="bi bi-geo-alt me-2 align-middle text-theme-1"></i> <span className="align-middle">13th Street. 47 W 13th St, New York, NY 10011, USA.</span></p>
                            </div>
                            <div className="card-footer justify-content-center text-center">
                                <a href="adminuiux-account-setting.html" className="btn btn-link"><i className="bi bi-gear"></i> Update Profile</a>
                            </div>
                        </div>

                        {/* subscription */}
                        <div className="card overflow-hidden mb-3 mb-lg-4">
                            <div className="card-body z-index-1">
                                <div className="row gx-3 align-items-center mb-3 mb-lg-4">
                                    <div className="col">
                                        <h6 className="mb-0">My Subscription</h6>
                                        <p className="text-secondary">3<span className="opacity-50">/5</span> User Active</p>
                                    </div>
                                    <div className="col-auto">
                                        <a href="adminuiux-subscription.html" className="btn btn-link btn-sm btn-square"><i className="bi bi-arrow-right"></i></a>
                                    </div>
                                </div>
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto">
                                        <div className="avatar avatar-40 rounded bg-theme-1-subtle text-theme-1"><i className="bi bi-gift"></i></div>
                                    </div>
                                    <div className="col">
                                        <h6 className="mb-0">MultiStore</h6>
                                        <p className="small text-secondary">Due: 26 July 2027</p>
                                    </div>
                                    <div className="col-auto text-end">
                                        <h6 className="mb-0">$20.00</h6>
                                        <p className="small text-secondary">per month</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* payment method */}
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-header">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto">
                                        <i className="bi bi-credit-card h5 me-1 avatar avatar-40 bg-theme-1-subtle text-theme-1 theme-green rounded"></i>
                                    </div>
                                    <div className="col">
                                        <h6 className="fw-medium mb-0">Payment Method</h6>
                                        <p className="text-secondary small">1 card saved</p>
                                    </div>
                                    <div className="col-auto">
                                        <a className="btn btn-square btn-sm btn-link"><i className="bi bi-plus-lg"></i></a>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                {/* Credit cards carousel card */}
                                <Swiper
                                    className="swipernav"
                                    slidesPerView={'auto'}
                                    spaceBetween={20}
                                >
                                    <SwiperSlide className="width-240">
                                        <div className="card mb-2 theme-blue bg-theme-1 overflow-hidden">
                                            <div className="card-body position-relative z-index-1">
                                                <div className="row gx-3 align-items-center mb-4">
                                                    <div className="col-auto align-self-center">
                                                        <i className="bi bi-amazon fs-4"></i>
                                                    </div>
                                                    <div className="col text-end">
                                                        <p className="fs-12">
                                                            <span className="opacity-75 small">City Bank</span><br />
                                                            <span className="">Credit Card</span>
                                                        </p>
                                                    </div>
                                                </div>
                                                <p className="fw-medium h6 mb-3">
                                                    000 0000 0001 546598
                                                </p>
                                                <div className="row gx-3 gx-lg-4">
                                                    <div className="col-auto fs-12">
                                                        <p className="mb-0 opacity-75 small">Expiry</p>
                                                        <p>09/023</p>
                                                    </div>
                                                    <div className="col text-end fs-12">
                                                        <p className="mb-0 opacity-75 small">Card Holder</p>
                                                        <p>DevUIUX</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row gx-3 gx-lg-4">
                                            <div className="col">
                                                <p className="text-secondary small mb-1">Expense</p>
                                                <p>1500.00 <small className="text-theme-1 theme-green">18.0% <i className="bi bi-arrow-up"></i></small></p>
                                            </div>
                                            <div className="col-auto text-end">
                                                <p className="text-secondary small mb-1">Limit Remain</p>
                                                <p>13500.00</p>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="width-240">
                                        <div className="card theme-teal bg-theme-1 mb-2 overflow-hidden">
                                            <div className="card-body position-relative z-index-1">
                                                <div className="row gx-3 align-items-center mb-4">
                                                    <div className="col-auto align-self-center">
                                                        <i className="bi bi-apple fs-4"></i>
                                                    </div>
                                                    <div className="col text-end">
                                                        <p className="fs-12">
                                                            <span className="opacity-75 small">City Bank</span><br />
                                                            <span className="">Debit Card</span>
                                                        </p>
                                                    </div>
                                                </div>
                                                <p className="fw-medium h6 mb-3">
                                                    000 0000 0001 546598
                                                </p>
                                                <div className="row gx-3 gx-lg-4">
                                                    <div className="col-auto fs-12">
                                                        <p className="mb-0 opacity-75 small">Expiry</p>
                                                        <p>09/023</p>
                                                    </div>
                                                    <div className="col text-end fs-12">
                                                        <p className="mb-0 opacity-75 small">Card Holder</p>
                                                        <p>DevUIUX</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row gx-3 gx-lg-4">
                                            <div className="col">
                                                <p className="text-secondary small mb-1">Expense</p>
                                                <p>3650.00 <small className="text-danger">11.0% <i className="bi bi-arrow-down"></i></small></p>
                                            </div>
                                            <div className="col-auto text-end">
                                                <p className="text-secondary small mb-1">Limit Remain</p>
                                                <p>35500.00</p>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide className="width-240">
                                        <div className="card theme-orange bg-theme-1 mb-2">
                                            <div className="card-body">
                                                <div className="row gx-3 align-items-center mb-4">
                                                    <div className="col-auto align-self-center">
                                                        <i className="bi bi-amazon fs-4"></i>
                                                    </div>
                                                    <div className="col text-end">
                                                        <p className="fs-12">
                                                            <span className="opacity-75 small">City Bank</span><br />
                                                            <span className="">Credit Card</span>
                                                        </p>
                                                    </div>
                                                </div>
                                                <p className="fw-medium h6 mb-3">
                                                    000 0000 0001 546598
                                                </p>
                                                <div className="row gx-3 gx-lg-4">
                                                    <div className="col-auto fs-12">
                                                        <p className="mb-0 opacity-75 small">Expiry</p>
                                                        <p>09/023</p>
                                                    </div>
                                                    <div className="col text-end fs-12">
                                                        <p className="mb-0 opacity-75 small">Card Holder</p>
                                                        <p>DevUIUX</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row gx-3 gx-lg-4">
                                            <div className="col">
                                                <p className="text-secondary small mb-1">Expense</p>
                                                <p>1500.00 <small className="text-theme-1 theme-green">18.0 <i className="bi bi-arrow-up"></i></small></p>
                                            </div>
                                            <div className="col-auto text-end">
                                                <p className="text-secondary small mb-1">Limit Remain</p>
                                                <p>13500.00</p>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                </Swiper>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-lg-7 col-xl-8">

                        {/* alert */}
                        <div className="alert alert-info alert-dismissible mb-3 mb-lg-4" role="alert">
                            <button type="button" className="btn btn-square btn-sm btn-link position-absolute top-0 end-0 m-2" data-bs-dismiss="alert"><i className="bi bi-x-lg"></i></button>
                            <div className="row gx-3 align-items-center mb-3">
                                <div className="col-auto">
                                    <i className="bi bi-telephone-plus h4 me-1 avatar avatar-40 rounded"></i>
                                </div>
                                <div className="col">
                                    <h6>Add a phone number</h6>
                                </div>
                            </div>
                            <div className="row gx-3 align-items-center">
                                <div className="col-12 col-sm">
                                    <p>Ensure you never lose access to your account and receive important account updates like billing and security alerts.</p>
                                </div>
                                <div className="col-auto col-sm-auto">
                                    <a href="adminuiux-account-setting.html" className="btn btn-sm btn-theme my-2">Add Phone</a>
                                </div>
                            </div>
                        </div>

                        {/* financial navigation */}
                        <div className="row gx-3 gx-lg-4">
                            <div className="col-12 col-sm-6 col-lg-6 col-xxl-4">
                                <div className="card mb-3 mb-lg-4">
                                    <div className="card-body text-center py-4">
                                        <i className="bi bi-cash-stack fs-2 avatar avatar-60 mb-3 text-theme-1 rounded-circle d-inline-block"></i>
                                        <h4 className="mb-1">1254.00 <small>USD</small></h4>
                                        <p className="mb-1">Your Earning</p>
                                        <p className="text-secondary mb-3">1 June 2022 - 31 June 2022</p>
                                        <p><a href="adminuiux-earning.html" className="btn btn-link btn-sm">View More</a></p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-6 col-lg-6 col-xxl-4">
                                <div className="card mb-3 mb-lg-4">
                                    <div className="card-body text-center py-4">
                                        <i className="bi bi-wallet fs-2 avatar avatar-60 mb-3 text-theme-1 rounded-circle d-inline-block"></i>
                                        <h4 className="mb-1">1400.00 <small>USD</small></h4>
                                        <p className="mb-1">Your Payouts</p>
                                        <p className="text-secondary mb-3">May 2022 <span className="badge text-bg-theme-1 theme-green mx-2">Success</span></p>
                                        <p><a href="adminuiux-payment.html" className="btn btn-link btn-sm">View All</a></p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 col-lg-12 col-xl-6 col-xxl-4">
                                <div className="card mb-3 mb-lg-4">
                                    <div className="card-body text-center py-4">
                                        <i className="bi bi-receipt fs-2 avatar avatar-60 mb-3 text-theme-1 rounded-circle d-inline-block"></i>
                                        <h4 className="mb-1">16</h4>
                                        <p className="mb-1">Your Statements</p>
                                        <p className="text-secondary mb-3">1 June 2022 - 25 June 2022</p>
                                        <p><a href="adminuiux-statement.html" className="btn btn-link btn-sm">View all</a></p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-6 col-lg-12 col-xl-6 col-xxl-12">
                                {/* overview */}
                                <div className="card mb-3 mb-lg-4">
                                    <div className="card-header">
                                        <h6 className="mb-0">Profile Overview</h6>
                                        <p className="text-secondary small"><i className="bi bi-eye me-1"></i> Visible to you only</p>
                                    </div>
                                    <div className="card-body">
                                        <div className="row gx-3">
                                            <div className="col-12 col-md-12 col-xxl-4 mb-3 mb-xxl-0">
                                                <div className="row gx-3 align-items-center">
                                                    <div className="col-auto">
                                                        <i className="bi bi-people avatar avatar-40 h5 bg-theme-1-subtle text-theme-1 rounded"></i>
                                                    </div>
                                                    <div className="col">
                                                        <h5 className="mb-0">36 <small>Profile views</small></h5>
                                                        <p className="text-secondary small">Your profile visitor</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-12 col-xxl-4 mb-3 mb-xxl-0">
                                                <div className="row gx-3 align-items-center">
                                                    <div className="col-auto">
                                                        <i className="bi bi-bar-chart avatar avatar-40 h5 bg-theme-1-subtle text-theme-1 rounded"></i>
                                                    </div>
                                                    <div className="col">
                                                        <h5 className="mb-0">54 <small className="text-theme-1 theme-green"><i className="bi bi-arrow-uo"></i> 5.65%</small> <small>interaction</small> </h5>
                                                        <p className="text-secondary small">Your posts are getting hits</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-12 col-md-12 col-xxl-4 mb-3 mb-lg-0">
                                                <div className="row gx-3 align-items-center">
                                                    <div className="col-auto">
                                                        <i className="bi bi-search avatar avatar-40 h5 bg-theme-1-subtle text-theme-1 rounded"></i>
                                                    </div>
                                                    <div className="col">
                                                        <h5 className="mb-0">144 <small>Search appearance</small></h5>
                                                        <p className="text-secondary small">You are in search result</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        {/* background */}
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-header">
                                <div className="row gx-3 align-items-center">
                                    <div className="col">
                                        <h6 className="mb-0">Experience</h6>
                                        <p className="text-secondary small">Currently working</p>
                                    </div>
                                    <div className="col-auto">
                                        <button className="btn btn-link btn-sm"><i className="bi bi-plus fs-6 me-2"></i><span>Add</span> <span className="d-none d-md-inline-block">New Role</span></button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body pb-0">
                                <div className="row gx-3 mb-4">
                                    <div className="col-auto">
                                        <figure className="avatar avatar-40 rounded coverimg">
                                            <img src={asset('assets/img/logo-512.png')} alt="" />
                                        </figure>
                                    </div>
                                    <div className="col">
                                        <h6 className="mb-1">Creative UI/UX Designer at <a href="https://adminuiux.com">DevUIUX</a>, London, UK</h6>
                                        <p className="small text-secondary">July 2013 - Present, 9 years 2 months</p>
                                        <p className="text-secondary">We are working in good company with reputed online presence and there are multi-disciplinary designers are available to give creative works.</p>
                                    </div>
                                </div>

                                <div className="row gx-3 mb-4">
                                    <div className="col-auto">
                                        <figure className="avatar-40 avatar rounded coverimg">
                                            <img src={asset('assets/img/adminuiux/image-1.jpg')} alt="" />
                                        </figure>
                                    </div>
                                    <div className="col">
                                        <h6 className="mb-1">Creative Designer at <a href="https://adminuiux.com">Micro Window</a>, Tipura, IN</h6>
                                        <p className="small text-secondary">July 2012 - 2013, 1 years 1 month</p>
                                        <p className="text-secondary">We are working in good company with reputed online presence and there are multi-disciplinary designers are available to give creative works.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* education */}
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-header">
                                <div className="row gx-3 align-items-center">
                                    <div className="col">
                                        <h6 className="mb-0">Education</h6>
                                        <p className="text-secondary small">Strong foundation</p>
                                    </div>
                                    <div className="col-auto">
                                        <button className="btn btn-link btn-sm"><i className="bi bi-plus fs-6 me-2"></i><span>Add</span> <span className="d-none d-md-inline-block">New Education</span></button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body pb-0">
                                <div className="row gx-3 mb-4">
                                    <div className="col-auto">
                                        <figure className="avatar-40 avatar rounded coverimg">
                                            <img src={asset('assets/img/adminuiux/image-2.jpg')} alt="" />
                                        </figure>
                                    </div>
                                    <div className="col">
                                        <h6 className="mb-1">M.Tech from <a href="https://adminuiux.com">London bridge University</a>, London, UK</h6>
                                        <p className="small text-secondary">July 2010 - July 2012, 3 years</p>
                                        <p className="text-secondary">This helped me a strong base to build my career and i always recommended to all people to must visit and study at University.</p>
                                    </div>
                                </div>

                                <div className="row gx-3 mb-4">
                                    <div className="col-auto">
                                        <figure className="avatar-40 avatar rounded coverimg">
                                            <img src={asset('assets/img/adminuiux/image-3.jpg')} alt="" />
                                        </figure>
                                    </div>
                                    <div className="col">
                                        <h6 className="mb-1">LifeTime Learning at <a href="https://adminuiux.com">Google Search</a>, Online remote</h6>
                                        <p className="small text-secondary">July 2008 - Present, 24 years and counting</p>
                                        <p className="text-secondary">Its been pleasure to mention that every student learned many things from online and most helpful finger tip resource available at google search and we thank you for all of help and support and improvement provided for us. You should try this and hope to have great learning.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        </>
    );
};

export default MyProfile;
